import { format, parseISO } from "date-fns";
import { de } from "date-fns/locale";
import { Link } from "react-router-dom";
import { SkillLevel } from "../../types";

interface Props {
  skillLevel: SkillLevel;
}

const Item = ({ skillLevel }: Props) => {
  return (
    <tr>
      <td className="px-6 py-4">
        <div className="flex items-center">
          <Link to={`/skillLevels/${skillLevel._id}/details`} className="ml-4">
            <div className="text-sm font-medium text-gray-900">
              {skillLevel.name}
            </div>
            <p className="text-sm text-gray-500 overflow-ellipsis">
              {skillLevel.description}
            </p>
          </Link>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
        {skillLevel.createdAt &&
          format(parseISO(skillLevel.createdAt), "do MMMM", {
            locale: de,
          })}
      </td>
    </tr>
  );
};

export default Item;
